<input
  type="text"
  class="form-control rounded-0 border-dark"
  [(ngModel)]="locationQuery"
  [ngbTypeahead]="searchLocations"
  [resultFormatter]="locationSearchFormatter.bind(this)"
  [inputFormatter]="locationInputFormatter.bind(this)"
  (ngModelChange)="onQueryChange($event)"
  (selectItem)="onTypeaheadSelect($event.item)" />
